import React from 'react';

const modifierState = {
  alt: false,
  shift: false,
  ctrl: false,
};
const modifierCallbacks = {
  alt: [],
  shift: [],
  ctrl: [],
};

function onKeyEvent(e) {
  if (e.altKey !== modifierState.alt) {
    modifierState.alt = e.altKey;
    for (const f of modifierCallbacks.alt) f(e.altKey);
  }
  if (e.shiftKey !== modifierState.shift) {
    modifierState.shift = e.shiftKey;
    for (const f of modifierCallbacks.shift) f(e.shiftKey);
  }
  if (e.ctrlKey !== modifierState.ctrl) {
    modifierState.ctrl = e.ctrlKey;
    for (const f of modifierCallbacks.ctrl) f(e.ctrlKey);
  }
}

document.addEventListener('keydown', onKeyEvent, true);
document.addEventListener('keyup', onKeyEvent, true);

function useModifier(key) {
  const [state, setState] = React.useState(modifierState[key]);
  React.useEffect(() => {
    modifierCallbacks[key].push(setState);
    return () => {
      const index = modifierCallbacks[key].indexOf(setState);
      if (index >= 0) modifierCallbacks[key].splice(index, 1);
    };
  }, [key]);
  return state;
}

export function useAlt() {
  return useModifier('alt');
}
export function useShift() {
  return useModifier('shift');
}
export function useCtrl() {
  return useModifier('ctrl');
}
